import React from 'react';
import { Dialog, DialogTitle, Typography } from '@mui/material';
import { BLUE, WHITE, WhiteLogo } from '@wave-engagement/wave-react';
import Button from './Button';

const EncouragementNote = ({ title, children, onClose, buttonText = 'Okay', isVisible = false, isLoading = false }) => {
  return (
    <Dialog open={isVisible} onClose={onClose}>
      <div style={{ backgroundColor: BLUE, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 30, color: 'white' }}>

        {/* Logo */}
        <img src={WhiteLogo} style={{ width: '200px', maxHeight: '8%', objectFit: 'contain', marginTop: 10, marginBottom: 20 }} />

        {/* Title */}
        {title &&
        <DialogTitle style={{ color: WHITE }}>
          {title}
        </DialogTitle>}

        {/* Children */}
        {children &&
        <div style={{ flex: 1 }}>
          {children}
        </div>}

        {/* Button */}
        <Button onClick={onClose} isLoading={isLoading} fullWidth secondary>{buttonText}</Button>
      </div>
    </Dialog>
  );
}
export default EncouragementNote;